import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FaCog } from "react-icons/fa";
import "../components/Products-Details.css";

import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Banner from "../components/SubProductsBanner";
import Partners from "../components/Partners_logo";
import secoImage from "../assets/SubProducts/cutting-tools/SECo.png";
import { productCategories } from "../productsContent";

const Offers = () => {
  const { categoryId } = useParams();
  const [activeIndex, setActiveIndex] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(0);

  // 🔹 Find the category based on slug
  const productsContent =
    productCategories.find((cat) => cat.slug === categoryId) ||
    productCategories[0];

  const {
    industries = [],
    substrates = [],
    products = [],
    bannerTitle,
    bannerImage,
    name,
  } = productsContent;

   const categories = [
    "Milling",
    "Turning",
    "Hole making",
    "Threading",
    "Tooling Systems"
  ];

  return (
    <>
      <Topbar />
      <Navbar />
      <Banner title={bannerTitle} image={bannerImage} />

      {/* Intro Section */}
      <section className="se-about-section">
        {/* <div className="se-intro">
          <h5 className="se-subtitle">
            <FaCog style={{ marginRight: "8px", color: "#0077b6" }} />
            {name}
          </h5>
          <p className="se-description">
            <strong>Sreenathji Enterprises</strong> provides a wide range of high
            quality and competitively priced products, which deliver outstanding
            value to its customers. SE is one of the leading distributors in
            Karnataka & Hosur region. Our approach to fine and specialty
            distribution is to be your most reliable and resourceful partner.
            we’ve sourced raw materials from suppliers around the world and
            marketed them to manufacturers serving key industrial and consumer
            marketplaces. These relationships are based on a long-standing
            expertise, exceptional follow-through and the fastest turnaround
            times in the business. Below are the product ranges which we offer.
          </p>
        </div> */}

        {/* Industries Section */}
        {industries.length > 0 && (
          <div className="se-industries">
            <h5 className="se-subheading">
              <FaCog style={{ marginRight: "8px", color: "#0077b6" }} />
              Our Products
            </h5>
            <h3 className="se-industries-title">Industries served</h3>

            <div className="se-industries-grid">
              {industries.map((industry, index) => {
                const Icon = industry.icon;
                return (
                  <div key={index} className="se-industry-card">
                    <Icon className="se-industry-icon" />
                    <span>{industry.name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </section>

      {/* Substrates Section */}
      {substrates.length > 0 && (
        <section className="substrate-section">
          <h2 className="substrate-title">Substrate</h2>
          <div className="substrate-grid">
            {substrates.map((item, index) => (
              <div className="substrate-card" key={index}>
                <img src={item.img} alt={item.name} className="substrate-image" />
                <div className="substrate-name">{item.name}</div>
              </div>
            ))}
          </div>
        </section>
      )}

{/* Cutting Tools Section - Show only on Cutting Tools page */}
{categoryId === "cutting-tools" && (
  <section className="cutting-tools-section">
    <h2 className="cutting-tools-title">Product Category</h2>
    <ul className="cutting-tools-list">
      {categories.map((cat, index) => (
        <li key={index} className={`cutting-tools-item item-${index + 1}`}>
          {cat}
        </li>
      ))}
    </ul>
  </section>
)}

      {/* Product Details Section */}
      <section className="pd-section">
  <h3 className="pd-heading">Product details</h3>

  {/* Desktop / Tablet Layout */}
  <div className="pd-desktop-layout">
    <div className="pd-tabs">
      {products.map((product, index) => (
        <div
          key={index}
          className={`pd-tab-item ${index === activeIndex ? "pd-tab-active" : ""}`}
          onClick={() => setActiveIndex(index)}
        >
          {product.name}
        </div>
      ))}
    </div>

    {products.length > 0 && (
      <div className="pd-content">
        <h4 className="pd-content-title">{products[activeIndex].name}</h4>
        <img
          src={products[activeIndex].img}
          alt={products[activeIndex].name}
          className="pd-content-image"
        />

        {Array.isArray(products[activeIndex].description) ? (
          <ul className="pd-content-description">
            {products[activeIndex].description.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
        ) : (
          <p className="pd-content-description">{products[activeIndex].description}</p>
        )}

        {/* PDF Button (only visible if PDF exists) */}
        {products[activeIndex].pdf && (
          <a
            href={products[activeIndex].pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="pd-enquiry-btn"
            style={{ textDecoration: "none" }}
          >
            View / Download PDF
          </a>
        )}
      </div>
    )}
  </div>

  {/* Mobile Accordion Layout */}
  <div className="pd-mobile-layout">
    {products.map((product, index) => (
      <div key={index} className="pd-accordion-item">
        <div
          className={`pd-accordion-title ${
            expandedIndex === index ? "pd-accordion-active" : ""
          }`}
          onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
        >
          {product.name}
        </div>

        {expandedIndex === index && (
          <div className="pd-accordion-content">
            <h4 className="pd-content-title">{product.name}</h4>
            <img
              src={product.img}
              alt={product.name}
              className="pd-content-image"
            />

            {Array.isArray(product.description) ? (
              <ul className="pd-content-description">
                {product.description.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            ) : (
              <p className="pd-content-description">{product.description}</p>
            )}

            {/* PDF Button (only visible if PDF exists) */}
            {product.pdf && (
              <a
                href={product.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="pd-enquiry-btn"
                style={{ textDecoration: "none" }}
              >
                View / Download PDF
              </a>
            )}
          </div>
        )}
      </div>
    ))}
  </div>
</section>

{categoryId === "cutting-tools" && (
  <section className="seco-unique-section-container">
    <div className="seco-unique-section-wrapper">
      <div className="seco-unique-section-left">
        <img
          src={secoImage}
          alt="About Us"
          className="seco-unique-section-image"
        />
      </div>

      <div className="seco-unique-section-right">
        <h2 className="seco-unique-section-title">SECO Materials</h2>
        <p className="seco-unique-section-text">
          A six-row, three-column color palette chart showing gradients from light to dark across blue, yellow, red, green, brown, and gray shades, labeled P, M, K, N, S, H.
        </p>
      </div>
    </div>
  </section>
)}


      <Contact />
      <Partners />
      <Footer />
    </>
  );
};

export default Offers;
